import { Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { useEffect, useState } from 'react'
import DialogCommunity from 'src/views/community/DialogCommunity'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import TableCommunity from '../../views/community/TableCommunity'

const CommunityList = () => {
    const [show, setShow] = useState(false)
    const [postId, setPostId] = useState(0)

    useEffect(() => {
        !show && setPostId(0)
    }, [show])

    useEffect(() => {
        postId > 0 && setShow(true)
    }, [postId])  

    return (
        <Page title="Community">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                        <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                            <Typography variant='h5' color='#666CFF'>
                                Community 관리
                            </Typography>
                        </Stack>
                    }
                    subtitle={
                        <Typography variant='body2'>
                            Community 질의 리스트를 보여줍니다.
                        </Typography>
                    }
                />
                <DialogCommunity show={show} setShow={setShow} postId={postId} />
                <Grid item xs={12}>
                    <TableCommunity setPostId={setPostId} />
                </Grid>
            </Grid>
        </Page>
    )
}

export default CommunityList